var KITRAS = KITRAS || {};

KITRAS.swatch_color_name = function(){
    $('body').on('change', '.option--colour select', function(){
        $(this).parent().find('.kt-color-name').text( $(this).val() );
    });
};

KITRAS.pdp_info_tabs = function(){

    var $header_tabs = $('.kt-tabs-header li');
    var $content_tabs = $('.kt-tab-single');

    $header_tabs.click(function(){
        $header_tabs.removeClass('active');
        $content_tabs.removeClass('active');

        $(this).addClass('active');
        $('#' + $(this).attr('data-tab')).addClass('active');
    });
};

KITRAS.sticky_header = function(){

    var sticky_class = 'sticky';
    var header_height = ($('.section-header').outerHeight() + 2) * -1;
    var sticky_offset = $('.section-header').offset().top;

    $(window).scroll(function(){
        var sticky = $('.section-header'),
        scroll = $(window).scrollTop();

        if (scroll >= sticky_offset) sticky.addClass(sticky_class);
        else sticky.removeClass(sticky_class);
    });

    $('.kt-header-overlay #content').css('margin-top', header_height + 'px');
    $(window).resize(function(){
        $('.kt-header-overlay #content').css('margin-top', header_height + 'px');
    });

    if( $('.section-image-with-text-overlay:first-child').length == 0 && $('.page-header--with-background:first-child').length == 0 ){
        $('body').removeClass('kt-header-overlay');
        $('#content').css('margin-top', '');
    }
};

KITRAS.menu_drawer = function(){

    /*$('body').on('click', '.mobile-navigation-drawer .navigation__tier-1 > li > a', function(e){
        e.preventDefault();
        e.stopPropagation();
        $(this).parent().toggleClass('navigation__item--open');
        return false;
    });*/

};

KITRAS.pdp_gift = function(){

    $('body').on('change', '.kt-gift-checkbox input', function(){
        $(this).parents('.kt-pdp-gift').find('.kt-gift-message').toggle();
    });

};

KITRAS.bundle_builder_app = function(){

    if( $('#bundle-builder-app--bundle--root').length ){

        // add bundle name to summary
        $('.bundle-builder-app--bundle--summary').prepend('<h3 class="h3 h3-style">'+ $('.bundle-builder-app--bundle--name').text() +'</h3>');

        var prev_step_name = '';
        var next_step_name = '';
    
        setInterval(function(){
            // label changes
            $('.bundle-builder-app--bundle--view-contents--button span:first-child').text('Review Variant');
            $('.bundle-builder-app--bundle--add-to-cart-button span').text('Add to cart');
            $('#bundle-builder-app--note-textarea').attr('placeholder', 'Optional message here');

            // steps navigation
            prev_step_name = $('.bundle-builder-app--bundle--section-breadcrumb--active').prev().find('a').text();
            next_step_name = $('.bundle-builder-app--bundle--section-breadcrumb--active').next().find('a').text();

            if( $('.bundle-builder-app--bundle--button--prev .kt-bb-step-nav').length ){
                $('.bundle-builder-app--bundle--button--prev .kt-bb-step-nav').text( prev_step_name );
            }
            else{
                $('.bundle-builder-app--bundle--button--prev').append('<span class="kt-bb-step-nav">'+ prev_step_name +'</span>');
            }

            if( $('.bundle-builder-app--bundle--button--next .kt-bb-step-nav').length ){
                $('.bundle-builder-app--bundle--button--next .kt-bb-step-nav').text( next_step_name );
            }
            else{
                $('.bundle-builder-app--bundle--button--next').append('<span class="kt-bb-step-nav">'+ next_step_name +'</span>');
            }

            //$('#bundle-builder-app--bundle-contents-modal');
        }, 100);

    }

};

KITRAS.regional_toggler = function(){

    var us_domain = 'kitras-dev-us.myshopify.com';
    var ca_domain = 'kitras-dev.myshopify.com';

    $('.kt-region-toggle').change(function(){
        window.location.replace( $(this).val() );
    });
};

KITRAS.store_locator = function(){

    if( $('body').hasClass('template-page--store-locator') ){

        var interval = setInterval(function(){
            if( $('.stockist-search-form').length ){
                $('.stockist-search-form').prepend('<h5>Postal Code / Address</h5>');
                $('.stockist-search-form').append('<p>Our retail partners all carry portions of our line, so once you have located a store,  please call to inquire about what items are available.</p>');
                clearInterval(interval);
            }
        }, 100);
    }

};

KITRAS.within_collection = function(){

    $('.kt-subcollection-list a').click(function(e){
        e.preventDefault();
        var cat_tag = $(this).attr('data-tag');
        $('.filter-group__item[data-tag="'+ cat_tag +'"]').click();
    });

    if( $('.filter-group[data-tag="category"] .filter-group__item--active').length ){
        $('.kt-filter-box .link-dropdown__button-text').text( $('.filter-group[data-tag="category"] .filter-group__item--active span').text() );
    }
    else{
        $('.kt-filter-box .link-dropdown__button-text').text( $('.filter-group[data-tag="category"] .filter-group__item span').first().text() );
    }

};

KITRAS.klaviyo_collection_bis = function(){
    $('body').on('click', '.quickbuy-container .quantity-submit-row__submit .klaviyo-bis-trigger', function(e){
        e.preventDefault();
        $('#klaviyo-data-handle-' + $(this).attr('data-klaviyo-handle') + ' .klaviyo-bis-trigger').trigger('click');
        return false;
    });
};

jQuery(document).ready(function($){

    // PDP Page
    KITRAS.swatch_color_name();
    KITRAS.pdp_info_tabs();
    KITRAS.pdp_gift();

    // Global
    KITRAS.sticky_header();
    KITRAS.menu_drawer();
    KITRAS.regional_toggler();

    // Bundle Builder App
    KITRAS.bundle_builder_app();

    // Store Locator Customizations
    KITRAS.store_locator();

    // Within the Collection
    KITRAS.within_collection();

});